var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, computed, observable } from "mobx";
import { AuthenticationConfiguration } from "@grumpycorp/warm-and-fuzzy-shared";
import JwtDecode from "jwt-decode";
// JWT functions are kind of clowny and return lots of `any`...
/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
let AuthStore = /** @class */ (() => {
    class AuthStore {
        constructor(authProvider, initialState = "unauthenticated") {
            this.accessToken = undefined;
            this.tenant = undefined;
            this.userName = undefined;
            this.userEmail = undefined;
            this.userPermissions = observable.array([]);
            this.state = initialState;
            this.authProvider = authProvider;
        }
        get isUserAuthenticated() {
            return this.state === "authenticated";
        }
        onUserLoggingIn() {
            this.state = "authenticating";
        }
        onUserLoggedIn(accessToken, idToken) {
            this.state = "authenticated";
            this.accessToken = accessToken;
            // Access token
            const decodedAccessToken = JwtDecode(accessToken);
            this.tenant =
                decodedAccessToken[AuthenticationConfiguration.CustomClaimsNamespace +
                    AuthenticationConfiguration.CustomClaims.Tenant];
            this.userPermissions.replace(decodedAccessToken.permissions);
            // Id token
            const decodedIdToken = JwtDecode(idToken);
            this.userName =
                decodedIdToken[AuthenticationConfiguration.CustomClaimsNamespace +
                    AuthenticationConfiguration.CustomClaims.UserName];
            this.userEmail =
                decodedIdToken[AuthenticationConfiguration.CustomClaimsNamespace +
                    AuthenticationConfiguration.CustomClaims.UserEmail];
        }
        onUserLoggedOut() {
            this.accessToken = undefined;
            this.tenant = undefined;
            this.userName = undefined;
            this.userEmail = undefined;
            this.userPermissions.clear();
            this.state = "unauthenticated";
        }
    }
    __decorate([
        observable,
        __metadata("design:type", String)
    ], AuthStore.prototype, "state", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], AuthStore.prototype, "accessToken", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], AuthStore.prototype, "tenant", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], AuthStore.prototype, "userName", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], AuthStore.prototype, "userEmail", void 0);
    __decorate([
        computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], AuthStore.prototype, "isUserAuthenticated", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuthStore.prototype, "onUserLoggingIn", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], AuthStore.prototype, "onUserLoggedIn", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AuthStore.prototype, "onUserLoggedOut", null);
    return AuthStore;
})();
export { AuthStore };
//# sourceMappingURL=index.js.map